import type { IconButtonProps } from "@braintrust/braintrust-ui-components";
import { IconButton } from "@braintrust/braintrust-ui-components";
import { CloseSVGIcon } from "@braintrust/braintrust-ui-components/Icons";

type BidCreateSuccessModalCloseButtonProps = Pick<
  IconButtonProps,
  "sx" | "variant" | "onClick"
>;

export const BidCreateSuccessModalCloseButton = ({
  ...props
}: BidCreateSuccessModalCloseButtonProps) => {
  return (
    <IconButton aria-label="close modal" size="medium" {...props}>
      <CloseSVGIcon />
    </IconButton>
  );
};
